import { MapPin, Calendar } from 'lucide-react';

/**
 * Location and date fields component
 */
export function LocationFields({ formData, onChange, today }) {
  return (
    <>
      {/* Location */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          <MapPin className="inline w-4 h-4 mr-1" />
          Lokalitet/Sted *
        </label>
        <input
          type="text"
          name="location_name"
          value={formData.location_name}
          onChange={onChange}
          placeholder="F.eks. Vindafjorden stasjon A"
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          required
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Adresse/Beskrivelse
        </label>
        <input
          type="text"
          name="location_address"
          value={formData.location_address}
          onChange={onChange}
          placeholder="Valgfri beskrivelse av stedet"
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        />
      </div>

      {/* Coordinates */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Breddegrad (valgfri)
          </label>
          <input
            type="number"
            step="0.000001"
            name="latitude"
            value={formData.latitude}
            onChange={onChange}
            placeholder="59.123456"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Lengdegrad (valgfri)
          </label>
          <input
            type="number"
            step="0.000001"
            name="longitude"
            value={formData.longitude}
            onChange={onChange}
            placeholder="5.123456"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>

      {/* Date and Depth */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <Calendar className="inline w-4 h-4 mr-1" />
            Ønsket dato *
          </label>
          <input
            type="date"
            name="preferred_date"
            value={formData.preferred_date}
            onChange={onChange}
            min={today}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            required
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Dybde
          </label>
          <select
            name="depth"
            value={formData.depth}
            onChange={onChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="3m">3 meter</option>
            <option value="5m">5 meter</option>
            <option value="10m">10 meter</option>
            <option value="custom">Annet</option>
          </select>
        </div>
      </div>

      {/* Priority */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Prioritet
        </label>
        <select
          name="priority"
          value={formData.priority}
          onChange={onChange}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="normal">Normal</option>
          <option value="urgent">Haster</option>
        </select>
      </div>
    </>
  );
}
